import React from 'react';
import { Tabs } from 'antd';
import FeedbackTemplate from './FeedbackTemplate';
import QuestionPage from './QuestionPage';

const { TabPane } = Tabs;

const Archive = () => {
  return (
    <Tabs defaultActiveKey="1" type="card" size="middle">
      <TabPane tab="Feedback" key="1">
        <FeedbackTemplate feedbackStatus="archived" />
      </TabPane>
      <TabPane tab="Questions" key="2">
        <QuestionPage questionStatus="archived" />
      </TabPane>
    </Tabs>
  );
};

export default Archive;
